export const ApplicationDetailsPageTemplate = {
  slots: ['SlbApplicationsFeatureSlot']
}